// api.js 文件优化
import axios from 'axios'
import Vue from 'vue'

const api = axios.create({
  baseURL: process.env.VUE_APP_API,
  timeout: 10000
})

// 响应拦截器
api.interceptors.response.use(
  response => response.data,
  error => {
    const errorMessage = error.response?.data?.message || 
      error.message 
    return Promise.reject(errorMessage)
  }
)

export default {
  fetchCardData(key) {
    return api.get(`/system/card/noToken/${key}`)
  },
   generateVcfCard(keyIden, language) {
    return api.get(`/system/card/generate-vcf`, {
      params: {
        keyIden,
        language
      }
    });
  },
  login(payload) {
    return api.post('/sys/login', payload)
  }
}